"use client";

import React from "react";
import { SecuredFooter } from "../ui/secured-footer";
import { type DposCryptoFlow } from "../../services/dposService";
import { DPOS_FIGMA_ASSETS } from "./dposFigmaAssets";
import { formatZarNumberForDisplay } from "../../utils/zarDisplayFormat";

interface CryptoPaymentOptionStepProps {
  amount: string;
  onSelect: (option: DposCryptoFlow) => void;
  onBack: () => void;
  onClose: () => void;
}

export default function CryptoPaymentOptionStep({
  amount,
  onSelect,
  onBack,
  onClose,
}: CryptoPaymentOptionStepProps) {
  const parsedAmount = parseFloat(amount);
  const formattedAmount = Number.isFinite(parsedAmount)
    ? formatZarNumberForDisplay(parsedAmount)
    : "0.00";

  return (
    <div className="bg-white border border-[#EBE9EF] rounded-[24px] flex flex-col items-center w-full min-h-[790px] relative">
      <button
        onClick={onBack}
        className="absolute left-8 top-8 border border-[#EBE9EF] rounded-full w-[48px] h-[48px] flex items-center justify-center hover:bg-[#F5F4F7] transition-colors"
      >
        <img src={DPOS_FIGMA_ASSETS.backNav} alt="Back" className="h-4 w-4" />
      </button>
      <button
        onClick={onClose}
        className="absolute right-8 top-8 border border-[#EBE9EF] rounded-full w-[48px] h-[48px] flex items-center justify-center hover:bg-[#F5F4F7] transition-colors"
      >
        <img
          src={DPOS_FIGMA_ASSETS.closeDelete}
          alt="Close"
          className="h-4 w-4"
        />
      </button>

      <div className="flex flex-1 flex-col items-center justify-center w-full max-w-[794px] mx-auto px-8 pt-24 pb-12">
        <div className="flex flex-col items-center text-center w-full pb-8">
          <h2 className="text-[32px] font-semibold leading-[40px] text-[#33125F] max-w-[405px]">
            How would the customer like to pay?
          </h2>
        </div>

        <div className="w-full mb-12 rounded-[16px] bg-[rgba(235,233,239,0.3)] h-[182px] flex flex-col items-center justify-center">
          <p className="text-[20px] font-normal leading-[24px] text-[#6D6584] mb-3">
            Amount to Pay
          </p>
          <div className="flex items-center gap-[11px]">
            <img
              src={DPOS_FIGMA_ASSETS.southAfricaFlag}
              alt="ZAR"
              className="w-10 h-10 rounded-full object-cover shrink-0"
            />
            <span className="text-[40px] font-bold leading-[32px] tracking-[-1.6px] text-[#423E51]">
              R {formattedAmount}
            </span>
          </div>
        </div>

        <div className="w-full pb-12">
          <div className="px-2 pb-5">
            <h3 className="text-[20px] font-semibold leading-[28px] text-[#6D6584]">
              Address book
            </h3>
          </div>

          <div className="space-y-2 px-0">
            <button
              onClick={() => onSelect("internal_wallet")}
              className="w-full h-[70px] rounded-[16px] border-2 border-[#57249C] bg-white flex items-center justify-center hover:opacity-95 transition-opacity"
            >
              <span className="text-[16px] font-semibold leading-[24px] text-[#57249C]">
                80eight
              </span>
            </button>
            <button
              onClick={() => onSelect("external_wallet")}
              className="w-full h-[70px] rounded-[16px] border border-[#CECBD7] bg-white flex items-center justify-center hover:bg-[#FCFCFD] transition-colors"
            >
              <span className="text-[16px] font-semibold leading-[24px] text-[#423E51]">
                Pay using another crypto wallet
              </span>
            </button>
          </div>
        </div>
      </div>

      <SecuredFooter className="w-full p-6 justify-center border-t border-[#EBE9EF] mt-auto" />
    </div>
  );
}
